import { patchCompany, humanizeOptionLabel } from "../../cs_edit";

let activeTagsEditorCell: HTMLElement | null = null;
let cancelActiveTagsEditor: (() => void) | null = null;

export function initCustomersTagsInlineEdit() {
  $(".customers-table .company-tags")
    .off("click.cs-inline-edit-tags")
    .on("click.cs-inline-edit-tags", function (e) {
      if ($(e.target).closest(".additional-tags-trigger").length) return;

      e.stopPropagation();

      const $cell = $(this);
      const cellEl = $cell[0] as HTMLElement;

      if (cancelActiveTagsEditor && activeTagsEditorCell !== cellEl) {
        cancelActiveTagsEditor();
      }

      if ($cell.find(".inline-tags-select").length) return;

      const currentTags: string[] = JSON.parse(
        $cell.attr("data-tags-value") || "[]",
      );
      const allTags: string[] = JSON.parse(
        $cell.attr("data-tags-options") || "[]",
      );

      const id = $cell.closest(".customer-row").attr("data-id");
      const csDatumId = $cell.closest(".customer-row").attr("data-cs-datum-id");
      if (!id) return;

      const originalHTML = $cell.html();
      let selectedTags = [...currentTags];

      // Build a custom multi-select list (click to toggle, no Ctrl needed)
      const $select = $("<div>", { class: "inline-tags-select" });

      allTags.forEach((tagValue) => {
        const isSelected = selectedTags.includes(tagValue);
        const $option = $("<div>", {
          class: "inline-tags-option" + (isSelected ? " selected" : ""),
          "data-value": tagValue,
        });

        const $checkbox = $("<span>", {
          class: "inline-tags-checkbox",
          html: isSelected ? "&#10003;" : "",
        });

        const $label = $("<span>", {
          class: "inline-tags-label",
          text: humanizeOptionLabel(tagValue),
        });

        $option.append($checkbox).append($label);

        $option.on("click", (ev) => {
          ev.stopPropagation();
          const idx = selectedTags.indexOf(tagValue);
          if (idx > -1) {
            selectedTags.splice(idx, 1);
            $option.removeClass("selected");
            $checkbox.html("");
          } else {
            selectedTags.push(tagValue);
            $option.addClass("selected");
            $checkbox.html("&#10003;");
          }
        });

        $select.append($option);
      });

      $cell.empty().addClass("is-editing").append($select);

      let closed = false;
      const $cellRef = $cell;

      function clearEditorState() {
        $(document).off("click.cs-tags-outside");
        $(document).off("keydown.cs-tags-escape");

        if (activeTagsEditorCell === $cellRef[0]) {
          activeTagsEditorCell = null;
          cancelActiveTagsEditor = null;
        }
      }

      function cancel() {
        if (closed) return;
        closed = true;

        clearEditorState();
        $cellRef.removeClass("is-editing");
        $cellRef.html(originalHTML);
      }

      function save() {
        if (closed) return;
        closed = true;

        clearEditorState();

        const tagsChanged =
          selectedTags.length !== currentTags.length ||
          selectedTags.some((t) => !currentTags.includes(t)) ||
          currentTags.some((t) => !selectedTags.includes(t));

        if (!tagsChanged) {
          $cellRef.removeClass("is-editing");
          $cellRef.html(originalHTML);
          return;
        }

        $cellRef.removeClass("is-editing");
        $cellRef.text("Saving...");
        $cellRef.addClass("inline-edit-saving");

        const csDatumAttributes: { [key: string]: any } = {
          tags: selectedTags,
        };

        if (csDatumId) {
          csDatumAttributes.id = csDatumId;
        }

        patchCompany(
          id!,
          { cs_datum_attributes: csDatumAttributes },
          $cellRef[0] as HTMLElement,
          originalHTML,
        );
      }

      activeTagsEditorCell = $cellRef[0] as HTMLElement;
      cancelActiveTagsEditor = cancel;

      $(document).on("click.cs-tags-outside", (ev) => {
        if (!$select[0].contains(ev.target as Node)) {
          save();
        }
      });

      $(document).on("keydown.cs-tags-escape", (ev) => {
        if (ev.key === "Escape") {
          ev.preventDefault();
          cancel();
        }
        if (ev.key === "Enter") {
          ev.preventDefault();
          save();
        }
      });
    });
}
